import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { Link, useNavigate } from 'react-router-dom';
import {
  logout,
  Logout,
  changeClient,
  ChangeClient,
} from '../../login/sessionReducer';
import Icon from '../../../components/icon/Icon';
import { resetState } from '../../../rootReducer';
import SideNavItem from '../../../factory/sidenav/components/SideNavItem';
import Avatar from '../../../components/Avatar';
import Auth, { UserClient } from '../../../Auth';

interface StateProps {
  clientId?: number;
  userClients: UserClient[];
}

interface DispatchProps {
  logout: Logout;
  changeClient: ChangeClient;
  resetState: typeof resetState;
}

interface SideNavFooterProps {}

type Props = StateProps & DispatchProps & SideNavFooterProps & WrappedComponentProps;

const SideNavFooterComponent: React.FC<Props> = ({
  logout,
  changeClient,
  resetState,
  intl,
  userClients,
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    resetState();
    logout(navigate);
  };

  const handleChangeClient = (clientId: number) => {
    changeClient(clientId, navigate, '/');
  };

  const jwt = Auth.getJWT();
  const fullName = `${jwt.name} ${jwt.surname}`;

  return (
    <section className="sidebar-footer">
      <div className="sidebar-footer--support">
        <Link to="/support">
          <Icon className="navigation-icon" icon="Question" />
          <span className="sidebar-footer--text">
            {intl.formatMessage({ id: 'help' })}
          </span>
        </Link>
      </div>

      <ul className="navigation">
        <SideNavItem
          submenuIcon="person_outline"
          submenuLabel="user.profile"
          icon={null}
          targetElement={
            <div className="sidebar-user">
              <button type="button" className="sidebar-user--button">
                <Avatar name={fullName} />
                <span className="sidebar-footer--text">
                  {intl.formatMessage({ id: 'user.profile' })}
                </span>
              </button>
            </div>
          }
        >
          <div className="navigation--between">
            <ul className="navigation">
              <SideNavItem
                link={`/settings/users/${jwt.id}`}
                label="user.profile"
                icon="person_outline"
              />
              {userClients.length > 1 &&
                userClients.map((userClient, index) => (
                  <SideNavItem
                    key={index}
                    icon="account_circle"
                    labelWithoutTranslation={userClient.client.name}
                    onClick={() => handleChangeClient(userClient.client.id)}
                    active={jwt.clientId === userClient.client.id}
                  />
                ))}
            </ul>

            <ul className="navigation sidebar-footer--bottom-items">
              <SideNavItem onClick={handleLogout} icon="forward" label="logout" />
            </ul>
          </div>
        </SideNavItem>
      </ul>
    </section>
  );
};

const mapStateToProps = (): StateProps => ({
  clientId: Auth.isUserAuthenticated() ? Auth.getJWT().clientId : undefined,
  userClients: Auth.isUserAuthenticated() ? Auth.getJWT().userClients! : [],
});

const mapDispatchToProps = (dispatch): DispatchProps =>
  bindActionCreators({ logout, changeClient, resetState }, dispatch);

const ConnectedSideNavFooter = connect(mapStateToProps, mapDispatchToProps)(SideNavFooterComponent);

export default injectIntl(ConnectedSideNavFooter);
